import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { ProductService } from "../../services/product.service";
import { ProductsActions } from "./products.actions";
import { map, mergeMap, filter, withLatestFrom } from "rxjs/operators";
import { Store, select } from "@ngrx/store";
import { selectAllPlans } from "./products.selects";
import { Plans } from "../../models/products.models";
import { TokensPack } from "../../class/tokensPack.class";

@Injectable()
export class ProductsEffects {
    constructor(
        private actions$: Actions,
        private productService: ProductService,
        private store: Store
    ) {}

    loadProducts$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ProductsActions.loadProducts),
            withLatestFrom(this.store.pipe(select(selectAllPlans))),
            filter(([_, plans]) => plans === undefined),
            mergeMap(() =>
                this.productService.getProducts().pipe(
                    map((products: { plans: Plans, tokensPack: TokensPack[] }) => ProductsActions.addProducts({ plans: products.plans, tokensPacks: products.tokensPack }))
                )
            )
        )
    );
}